var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"wrap"},[_c('span',{staticClass:"copyright"},[_vm._v("© -")]),_c('h1',[_vm._v(" Aiueokashi ")]),_c('span',[_vm._v("- 2022")])])])}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/share/Footer.vue?vue&type=template&id=caa6aff4&scoped=true&
// module id = null
// module chunks = 